const SET_DELIVERY_TERMINAL = 'SET_DELIVERY_TERMINAL'
const SET_DELIVERY_CITY = 'SET_DELIVERY_CITY'

export default {
  namespaced: true,

  state: {
    deliveryCity: null,
    deliveryTerminal: null // select pickup point. Should be saved
  },

  getters: {
    getDeliveryTerminal(state) {
      return state.deliveryTerminal
    },
    getDeliveryCity(state) {
      return state.deliveryCity
    }
  },

  mutations: {
    [SET_DELIVERY_TERMINAL](state, deliveryTerminal) {
      state.deliveryTerminal = deliveryTerminal
    },
    [SET_DELIVERY_CITY](state, deliveryCity) {
      state.deliveryCity = deliveryCity
    }
  },

  actions: {
    setDeliveryTerminal({ commit }, deliveryTerminal) {
      commit(SET_DELIVERY_TERMINAL, deliveryTerminal)
    },
    setDeliveryCity({ commit }, deliveryCity) {
      commit(SET_DELIVERY_CITY, deliveryCity)
    }
  }
}
